export type Environment = "development" | "staging" | "uat" | "production";

export const getEnvironment = (): Environment => {
  // Jest sets NODE_ENV="test" and leaves REACT_APP_ENVIRONMENT unset.
  // Treat tests as non-production so components render as they would in dev.
  if (process.env.NODE_ENV === "test") return "development";
  return (process.env.REACT_APP_ENVIRONMENT as Environment) ?? "production";
};

export const isProduction = () => getEnvironment() === "production";

export const isUat = () => getEnvironment() === "uat";

/**
 * Whether this build is one of the two pre-production environments.
 *
 * An allow-list, not `!isProduction()`: a tool restricted to dev and staging
 * must stay out of UAT too, and a future environment name should be excluded
 * until somebody adds it deliberately. Mirrors the same allow-list on the
 * API's `IntegrationQueueController`. EN-5174.
 */
export const isDevOrStaging = () => {
  const environment = getEnvironment();
  return environment === "development" || environment === "staging";
};
